import ColorChip from "../../UI/chips/ColorChip";
import InputTextField from "../../UI/input/InputTextField";
import Checkbox from "../../UI/input/Checkbox";
import RowCell from "../../UI/table/RowCell";

const TeamSettingsRow = ({
  colorHex,
  chipColor,
  teamName,
  onNameChange,
  grouped,
  onGroupChange,
}: {
  colorHex: string;
  chipColor: string;
  teamName: string;
  onNameChange: (newName: string) => void;
  grouped: boolean;
  onGroupChange: (isGroup: boolean) => void;
}) => {
  return (
    <li className="flex">
      <RowCell width={174}>
        <ColorChip text={colorHex} classes="uppercase" color={chipColor} />
      </RowCell>

      <RowCell>
        <InputTextField
          value={teamName}
          direction="COLUMN"
          onInputChange={onNameChange}
          classes="w-full"
          label=""
          placeholder=""
        />
      </RowCell>

      <RowCell>
        <Checkbox checked={grouped} onChange={onGroupChange} />
      </RowCell>
    </li>
  );
};

export default TeamSettingsRow;
